import { render, staticRenderFns } from "./EditUserGroup.vue?vue&type=template&id=3c39ba6b"
import script from "./EditUserGroup.vue?vue&type=script&lang=js"
export * from "./EditUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports